"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TimelineStatusStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineStatusStore"));

var _immutable = require("immutable");

var TimelineDateRangeDependency = {
  stores: [_TimelineStatusStore.default],
  deref: function deref() {
    var dateRange;

    var timelineStatus = _TimelineStatusStore.default.get('timelineStatus');

    var fromDate = timelineStatus.getIn(['originalPayload', 'fromDate']);
    var toDate = timelineStatus.getIn(['originalPayload', 'toDate']);
    var now = timelineStatus.get('now');

    if (fromDate) {
      dateRange = (0, _immutable.Map)({
        fromDate: fromDate,
        toDate: toDate,
        now: now
      });
    } else {
      dateRange = _TimelineStatusStore.default.get('firstDateRange');
    }

    return dateRange;
  }
};
var _default = TimelineDateRangeDependency;
exports.default = _default;
module.exports = exports.default;